export default __webpack_public_path__ + "static/media/bubble.eb69415a.png";